// @ts-nocheck
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import WaveSurfer from 'wavesurfer.js';
import styled from 'styled-components';
import { faPlay, faPause, faDownload } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { creatorUpsellModalActions } from "app/components/CreatorUpsellModal/slice/index";
import { connect } from "react-redux";
import { store } from 'index';
import { duration } from '@mui/material';

const DEAFULT_WAVEFORM_HEIGHT = 30;
const DEAFULT_WAVEFORM_CONTAINER_HEIGHT = 60;

const WaveformContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: ${props => props.small ? '40px' : DEAFULT_WAVEFORM_CONTAINER_HEIGHT + 'px'};
  width: 100%;
  background: #180D23;
  padding: ${props => props.small ? '5px' : '8px'};
  box-sizing: border-box;
  border: 1px solid #00000000;
  background: #251A30;
  border-radius: 8px;
  overflow: hidden;

  &:hover {
    padding: ${props => props.small ? '5px' : '8px'};
    border: 1px solid #FF74E933;
  }
`;

const Wave = styled.div`
  width: 100%;
  height: ${props => props.small ? '40px' : DEAFULT_WAVEFORM_HEIGHT + 'px'};
`;


const PlayButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props => props.small ? '30px' : '40px'};
  height: ${props => props.small ? '30px' : '40px'};
  background: ${props => props.hidePlayButtonBackground ? 'none' : '#F5E1FF'};
  border-radius: 50%;
  border: none;
  outline: none;
  cursor: pointer;
  padding-bottom: 3px;
  margin-right: ${props => props.small ? '5px' : '10px'};
  color: #0C0810;
  z-index: 100;
  &:hover {
    background: #FF74E9;
  }
`;
const RightButton = styled.div`
  flex-shrink: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${props => props.small ? '5px' : '10px'};
  // width: ${props => props.small ? '30px' : '40px'};
  height: ${props => props.small ? '30px' : '40px'};
  border-radius: 50%;
  border: none;
  outline: none;
  cursor: pointer;
  // For FontAwesomeIcon
  font-size: ${props => props.small ? '30px' : '40px'};
  
  .fa-check {
    color: #55CDC4;
    max-width: 24px;
    padding-left: 16px;
    padding-right: 16px;
  }
`
const DownloadButton = styled.a`
  color: #F5E1FF;
  &:hover {
    color: #FF74E9;
  }
`;

class Waveform extends Component {
  constructor(props) {
    super(props);
    // @ts-ignore
    this.id = this.props.uniqueKey || Math.random().toString(36).substr(2, 9);
  }

  state = {
    playing: false,
  };
  waveform: any;
  audioContext: any;

  componentDidMount() {
    let isSmall = !!this.props.small
    // @ts-ignore
    const uniqueKey = this.props.uniqueKey || '';
    const track = document.querySelector('#track' + uniqueKey);
    this.waveform = WaveSurfer.create({
      barWidth: 3,
      cursorWidth: 1,
      container: '#waveform' + uniqueKey,
      backend: 'WebAudio',
      height: isSmall ? 40 : DEAFULT_WAVEFORM_HEIGHT,
      progressColor: '#FF74E9',
      responsive: true,
      waveColor: 'rgba(255,116,233,0.24)',
      cursorColor: 'transparent',
      xhr: { mode: 'cors', method: 'GET', referrer: 'client' },
    });

    this.waveform.load(track);
    window.addEventListener('controlla-audio-play', this.handleGlobalAudioPlay);
  };

  componentWillUnmount() {
    if (this.waveform) {
      this.waveform.destroy();
    }
    window.removeEventListener('controlla-audio-play', this.handleGlobalAudioPlay);
  }

  componentDidUpdate(prevProp) {
    // @ts-ignore
    const uniqueKey = this.props.uniqueKey || '';
    const track = document.querySelector('#track' + uniqueKey);
    if (this.props.url !== '' && this.props.url !== prevProp.url) {
      this.waveform.load(track);
    }
  }

  handleGlobalAudioPlay = (event) => {
    // @ts-ignore
    if (event.detail.id !== this.id && this.state.playing) {
      this.setState({ playing: false });
      this.waveform.pause();
    }
  };

  handlePlay = () => {
    const isPlaying = !this.state.playing;
    if (isPlaying) {
      const event = new CustomEvent('controlla-audio-play', { detail: { id: this.id } });
      window.dispatchEvent(event);
    }
    this.setState({ playing: isPlaying });
    this.waveform.playPause();
  };

  handleLoadedMetadata = (e) => {
    if (this.props.onLoadedMetadata) this.props.onLoadedMetadata(e);
  }

  handleDownloadClicked = () => {
    let url = this.props.url || '';
    let userProfile = this.props.userProfile

    // if subscribed
    if (userProfile.plan?.includes('creator') || userProfile.plan?.includes('starter')) {
      window.location.href = url
    } else {
      console.log('clicked download')
      store.dispatch(creatorUpsellModalActions.updateTitle("Subscribe to download this file"));
      store.dispatch(creatorUpsellModalActions.open())
    }
  }
  

  render() {
    // TODO figure out why normal way of doing PropTypes props error typescript
    // @ts-ignore
    let url = this.props.url || '';
    let filename = this.props.filename || '';
    let customLabel = this.props.customLabel || '';
    let duration = this.props.duration || 0;
    // @ts-ignore
    let uniqueKey = this.props.uniqueKey || '';
    // @ts-ignore
    let playButtonElement = this.props.leftButtonElement || (
      !this.state.playing ? <FontAwesomeIcon icon={faPlay} size="1x"/> : <FontAwesomeIcon icon={faPause} size="1x"/>
    );

    let downloadButtonElement = this.props.downloadButtonElement || (
        <DownloadButton
            // @ts-ignore
            onClick={this.handleDownloadClicked}
        >
          <FontAwesomeIcon icon={faDownload} size="2xs"/>
        </DownloadButton>
    );

    // @ts-ignore
    let hidePlayButtonBackground = !!this.props.playButtonElement

    let isDownloadable = !!this.props.isDownloadable

    let isUploading = !!this.props.isUploading

    let isSmall = !!this.props.small
    
    let hideTimestamp = !!this.props.hideTimestamp
    
    // control filename visibility
    let hideFilename = !!this.props.hideFilename

    return (
      <div className="audio-file-list-item" key={uniqueKey}>
        <WaveformContainer small={isSmall}>
          <PlayButton
            // @ts-ignore
            hidePlayButtonBackground={hidePlayButtonBackground}
            onClick={this.handlePlay}
            small={isSmall}
          >
            {playButtonElement}
          </PlayButton>
          <WaveformAndHeaderWrapper>
            <WaveformTitleAndDuration>
              {!hideFilename && (
                <WaveformTitle>
                  {customLabel || filename}
                </WaveformTitle>
              )}
              {!hideTimestamp && (
                <WaveformDuration>
                  {Math.floor(duration / 60)}:{String(Math.floor(duration % 60)).padStart(2, '0')}
                </WaveformDuration>
              )}
            </WaveformTitleAndDuration>
            <Wave id={'waveform' + uniqueKey} small={isSmall} />
          </WaveformAndHeaderWrapper>
          <audio id={'track' + uniqueKey} src={url} crossOrigin="anonymous" onLoadedMetadata={this.handleLoadedMetadata}/>
          <RightButton small={isSmall}>
            {downloadButtonElement}
          </RightButton>
        </WaveformContainer>
      </div>
    );
  }
};


const WaveformAndHeaderWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
`;

const WaveformTitleAndDuration = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const WaveformTitle = styled.div`
  font-family: 'Jura', sans-serif;
  font-size: 16px;
  text-align: left;
  padding-bottom: 0;
  margin-bottom: 0;
  /* start hacky fix for overflowing waveform when long filename */
  flex-shrink: 1;
  flex-grow: 1;
  max-width: 600px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  
  @media only screen and (max-width: 600px) {
  }
  /* end */
`;

const WaveformDuration = styled.div`
  font-family: 'Jura', sans-serif;
  font-size: 16px;
  text-align: left;
  
`;



export default Waveform;